import styles from "./styles.module.css"

function PlanoCard({codigoGrupo, vagasGrupo, nParcelas, valorParcela, menorLance, active, ...props}){
    return(
        <button className={`${styles.planoContainer} ${active && styles.active}`} {...props}>
            <div className={styles.grupoBox}>
                <div>
                    {
                        codigoGrupo === 0 ?
                            "Grupo em formação" :
                            `Grupo (${codigoGrupo}) com ${vagasGrupo} vagas disponíveis`
                    }
                </div>
                <div><b>{nParcelas} parcelas de {valorParcela}</b></div>
            </div>
            <div className={styles.lanceBox}>
                <div>Menor Lance*</div>
                {menorLance === 0 ? <b>Sem histórico</b> : <b>{menorLance.toFixed(2)}%</b>}
            </div>
        </button>
    )
}

export default PlanoCard